import { ActionReducerMap } from '@ngrx/store';
import { ConsumerMenuFeatureState } from '../models/consumer-menu-state.model';
import { consumerMenuAddonsStateStateReducer } from '../reducers/consumer-menu-addons.reducer';
import { consumerMenuPageReducer } from '../reducers/consumer-menu-page.reducer';

export const consumerMenuReducers: ActionReducerMap<ConsumerMenuFeatureState> = {
  consumerMenuAddons: consumerMenuAddonsStateStateReducer,
  consumerMenuPage: consumerMenuPageReducer,
};
